import { type ButtonProps } from '@autone/ui-next/atoms';
import { Provider } from 'react-redux';

import { useGetAssortmentCustomerConfigQuery } from '../../redux/assortment';
import legacyStore from '../../redux/store';

import { DownloadTemplateModal } from './download-template-modal';
import { UploadTemplateModal } from './upload-template-modal';

interface AssortmentTemplateModalsProps {
  uploadButtonVariant?: ButtonProps['variant'];
}

const AssortmentTemplateModalsInner = ({
  uploadButtonVariant,
}: AssortmentTemplateModalsProps) => {
  const { data, isLoading } = useGetAssortmentCustomerConfigQuery({});

  if (isLoading) {
    return null;
  }

  const { use_data_feed_for_assortment, use_data_feed_for_initial_allocation } =
    data ?? {};

  const usesBothDataFeeds =
    use_data_feed_for_assortment && use_data_feed_for_initial_allocation;

  return (
    <>
      <DownloadTemplateModal />
      {!usesBothDataFeeds && (
        <UploadTemplateModal variant={uploadButtonVariant} />
      )}
    </>
  );
};

export const AssortmentTemplateModals = (
  props: AssortmentTemplateModalsProps = {},
) => (
  // Having a separate provider here that uses legacy redux store
  // is necessary for this piece of legacy UI
  // to work with the new redux store, since we don't want to pollute
  // the new redux store with legacy reducers and middlewares.
  <Provider store={legacyStore}>
    <AssortmentTemplateModalsInner {...props} />
  </Provider>
);
